import gql from 'graphql-tag';

export const GET_TEMPLATES = gql`
  query getTemplates {
    templates {
      _id
      name
    }
  }
`;

export const GET_CLIENTS = gql`
  query getClients {
    projectManagement {
      clients {
        _id
        name
        shortName
      }
    }
  }
`;

export const ADMIN_GET_USER_BY_ID = gql`
  query getUserByIdAsAdmin($userId: String!) {
    admin {
      user(userId: $userId) {
        _id
        firstName
        lastName
        payrollId
        accountActive
        emails {
          address
        }
        projects {
          _id
          name
          projectManagers {
            _id
            name
          }
        }
        approvers {
          type
          value
        }
        delegatedApprovers {
          type
          value
        }
        imageUrl
        title
        role
        groups
        integration {
          sourceId
        }
        settings {
          notifications {
            timesheetReminders
          }
        }
      }
    }
  }
`;

export const ADMIN_GET_USERS = gql`
  query getUsersAsAdmin($manualUser: Boolean, $excludeInactive: Boolean) {
    admin {
      users(manualUser: $manualUser, excludeInactive: $excludeInactive) {
        _id
        firstName
        lastName
        lastActiveOn
        payrollId
        role
        accountActive
        employeeType
        workCalendar
        department
        emails {
          address
          verified
        }
        approvers {
          type
          value
        }
        delegatedApprovers {
          type
          value
        }
        integration {
          sourceId
        }
      }
    }
  }
`;

export const GET_TIMESHEET_THRESHOLD = gql`
  query getTimesheetThreshold {
    timesheetThreshold
  }
`;
export const GET_WEEKLY_REMINDER_EMAIL = gql`
  query getTimesheetThreshold {
    weeklyReminderEmailJob
  }
`;

export const EMAIL_STATS_RECEIVERS = gql`
  query emailStatsReceivers {
    admin {
      emailStatsRecievers
      users {
        _id
        firstName
        lastName
        lastActiveOn
        payrollId
        accountActive
        emails {
          address
          verified
        }
        approvers {
          type
          value
        }
        delegatedApprovers {
          type
          value
        }
      }
    }
  }
`;

export const UPDATE_SNAPSHOTS = gql`
mutation updateSnapshots($limit: Int, $timesheetId: ID, $projectId: ID, $endDate: String) {
  updateTimesheetSnapshots(limit: $limit, timesheetId: $timesheetId, projectId: $projectId, endDate: $endDate)
}
`;

export const GET_TIMESHEET_SNAPSHOT_DISCREPANCIES = gql`
  query getTimesheetSnapshotDiscrepancies($startDate: String!, $endDate: String!) {
    admin {
      timesheetSnapshotDiscrepancies(startDate: $startDate, endDate: $endDate) {
        timesheetId
        userId
        userEmail
        endDate
        missingSnapshot
        timesheetStatus
        timesheetTotalHours
        snapshotStatus
        snapshotTotalHours
        discrepancies {
          field
          expected
          actual
        }
      }
    }
  }
`;

export const GET_BUDGET_INTEGRITY_CHECK = gql`
  query getBudgetIntegrityCheck {
    admin {
      budgetIntegrityCheck {
        projectId
        projectName
        clientName
        status
        storedBudgetUsed
        computedBudgetUsed
        storedTotalCost
        computedTotalCost
        storedTotalApprovedHours
        computedTotalApprovedHours
        budget
        budgetUsedUpdatedAt
        discrepancyPct
      }
    }
  }
`;

export const GET_TIMEOFF_INTEGRITY_CHECK = gql`
  query getTimeOffIntegrityCheck {
    admin {
      timeOffIntegrityCheck {
        orphanedTransactions {
          userId
          userEmail
          userName
          issueType
          timeOffType
          details
          transactionId
          timesheetId
        }
        duplicateTransactions {
          userId
          userEmail
          userName
          issueType
          timeOffType
          details
          transactionId
          timesheetId
        }
        negativeBalances {
          userId
          userEmail
          userName
          issueType
          timeOffType
          details
          transactionId
          timesheetId
        }
        totalUsersChecked
        totalIssues
      }
    }
  }
`;
